// extracted by mini-css-extract-plugin
module.exports = {"container":"GalleryDetails_container__408Nk","back":"GalleryDetails_back__bIjrv","noItems":"GalleryDetails_noItems__Uvj5x"};